export default __webpack_public_path__ + "static/media/who-03.2fe2a09d.png";